"use client";

import Image from "@/components/Image";
import { CampaignType } from "../apis/campaign";

type Props = {
    idSelect: string;
    data: CampaignType[];
    onSelectCampaign: (id: number) => void;
};

export default function ListCampaign({
    idSelect,
    data,
    onSelectCampaign,
}: Props) {
    return (
        <div className="bg-[#121212] h-full rounded-xl px-4 py-4 overflow-auto text-white flex flex-row md:flex-col">
            {data.map((item, index) => {
                const shortDesc = item.title?.split(" ");
                return (
                    <button
                        type="button"
                        className="min-w-32 flex flex-col md:flex-row items-center gap-4 cursor-pointer hover:opacity-90 hover:bg-[#b6c38f] rounded-2xl p-2 md:p-4 md:h-[100px] overflow-hidden md:mb-4"
                        style={{
                            backgroundColor: idSelect === item.title ? "#b6c38f" : "",
                        }}
                        key={index.toString()}
                        onClick={() => onSelectCampaign(item.id)}
                    >
                        <Image
                            src={item.thumbnailImage}
                            width={80}
                            height={68}
                            alt=""
                            className="rounded-lg w-full md:w-[80px] h-[68px] object-cover"
                        />
                        <span className="font-medium md:h-full md:overflow-hidden md:text-ellipsis">
                            {shortDesc.slice(0, 4).join(" ")}
                            {shortDesc.length > 4 && "..."}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
